// extracted by mini-css-extract-plugin
export var darkBlue = "#003e52";
export var darkGreen = "#3b693d";
export var green = "#3dae2b";
export var lightGreen = "#93d500";
export var newsGreen = "#ecf5d7";
export var orange = "#f90";
export var yellow = "#fbc900";
export var paleBlue = "#64a1bb";
export var blue = "#67b9e8";
export var blueishGrey = "#adc6d6";
export var coolGrey = "#e1e2e0";
export var white = "#fff";
export var almostWhite = "#f2eded";
export var lightGrey = "#d3d3d3";
export var lightishGrey = "#aba9a9";
export var grey = "#828382";
export var darkishGrey = "#666";
export var darkGrey = "#4b4d4b";
export var almostBlack = "#333";
export var error = "#ff3a3a";
export var warning = "#ffd162";
export var success = "#1ebc7b";
export var section = "OurProductsHighlightsSection-module--section--3nayC";
export var searchBox = "OurProductsHighlightsSection-module--searchBox--2ld6v";
export var noSearchResultsHint = "OurProductsHighlightsSection-module--noSearchResultsHint--3r4rt";
export var sectionTitle = "OurProductsHighlightsSection-module--sectionTitle--1dBjw";
export var container = "OurProductsHighlightsSection-module--container--2ag5S";
export var greenCirclesBackground = "OurProductsHighlightsSection-module--greenCirclesBackground--2VWjd";
export var leftSide = "OurProductsHighlightsSection-module--leftSide--3Hmh8";
export var content = "OurProductsHighlightsSection-module--content--3bH4y";
export var card = "OurProductsHighlightsSection-module--card--1qZ7T";
export var lastCard = "OurProductsHighlightsSection-module--lastCard--3iQld OurProductsHighlightsSection-module--card--1qZ7T";
export var cardImage = "OurProductsHighlightsSection-module--cardImage--BEPAl";
export var cardTextContainer = "OurProductsHighlightsSection-module--cardTextContainer--12qrH";
export var title = "OurProductsHighlightsSection-module--title--rgp_a";
export var paragraph = "OurProductsHighlightsSection-module--paragraph--1AMuv";
export var link = "OurProductsHighlightsSection-module--link--3cKso";
export var rightSide = "OurProductsHighlightsSection-module--rightSide--10OJ-";